import React from 'react';
import { Row, Col, Card, Tag } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import styles from './index.less'; // Ensure you have styles defined here or update accordingly

const { Meta } = Card;

function CustomSignatureDetail({ data }) {
  const {
    messageFail,
    description,
    risk: severity,
    service,
    group: type,
    cloud,
    RemediationSteps,
  } = data;

  return (
    <div>
      <Card
        // style={{
        //   marginTop: '7px',
        // }}
        bodyStyle={{ paddingBottom: '0px' }}
        bordered={false}
      >
        <div className="sig-card" style={{ marginTop: -24 }}>
          <Row type="flex" justify="space-between" style={{ marginBottom: 25 }}>
            <Col span={24}>
              <h2 style={{ fontSize: '18px', fontWeight: 'bold' }}>{messageFail}</h2>
              <p style={{ color: '#888' }}>{description}</p>
            </Col>
          </Row>

          <Row type="flex" justify="space-between" style={{ marginBottom: 25 }}>
            <Col span={3}>
              <Meta
                title={<div className={styles.title}>Status</div>}
                description={
                  <div className={styles.text}>
                    <CloseCircleOutlined
                      style={{
                        color: '#F5222D', // Red color for "fail" status
                        fontSize: 30,
                      }}
                    />
                  </div>
                }
              />
            </Col>
            <Col span={3}>
              <Meta
                title={<div className={styles.title}>Severity</div>}
                description={
                  <div className={styles.text}>
                    <Tag color="red">{severity}</Tag>
                  </div>
                }
              />
            </Col>

            <Col span={4}>
              <Meta
                title={<div className={styles.title}>Service</div>}
                description={
                  <div className={styles.text}>
                    <Tag color="orange">{service}</Tag>
                  </div>
                }
              />
            </Col>

            <Col span={4}>
              <Meta
                title={<div className={styles.title}>Type</div>}
                description={
                  <div className={styles.text}>
                    <Tag color="blue">{type}</Tag>
                  </div>
                }
              />
            </Col>
          </Row>
        </div>
      </Card>
    </div>
  );
}

export default CustomSignatureDetail;
